import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { signalWithStorage } from "@/utils/signal_utils"
import { computed } from "@preact/signals"
import { getAdIdFromUrl } from "@/utils/adId"
import { createLogger } from "@/utils/logger"

const logger = createLogger("ga")

export const gaDetailSinal = signalWithStorage<
    Partial<MemberApiTypes.Fetcher.Result.RefGetBuriedPointDetailData> | undefined
>(undefined, "ga_detail")

const fetchBuriedPointDetail = async (
    props: MemberApiTypes.Fetcher.Props.RefGetBuriedPointDetailProps,
) => {
    await ApiSignalFetchers.fetchDataSignalBuriedPointDetail(props)
    gaDetailSinal.value = ApiSignals.dataSignalBuriedPointDetail.value
    return ApiSignals.dataSignalBuriedPointDetail.value
}

const AdId = computed(async () => {
    return gaDetailSinal.value?.ad_id ?? ""
})

interface GAConfig {
    gtag_id?: string
    api_secret?: string
    event_token?: {
        first_deposit_event?: string
        login_success_event?: string
        third_deposit_event?: string
        first_withdraw_event?: string
        second_deposit_event?: string
    }
}

const GtagId = computed(async () => {
    const config = gaDetailSinal?.value?.config as GAConfig | undefined
    return config?.gtag_id ?? ""
})

export const adIdSignal = signalWithStorage<string | undefined>(undefined, "ad_id")

const setGtmId = async () => {
    const adId = getAdIdFromUrl()
    logger.debug("adId init:", adId)
    if (adId) {
        adIdSignal.value = adId
        await fetchBuriedPointDetail({ ad_id: adIdSignal.value })
        const gtagId = await GtagId.value

        if (gtagId && window.setDynamicGtmId) {
            window.setDynamicGtmId(gtagId)
            console.log("Updated GTM ID to:", gtagId)
        }
    } else {
        logger.info("adid init error!")
    }
}

export { fetchBuriedPointDetail, AdId, GtagId, setGtmId }
